import styled from 'styled-components'

export default {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 54px 28px;
		gap: 36px;
	`,

	AdminExams: styled.div`
		display: flex;
		flex-direction: column;
		gap: 8px;
		width: 100%;
	`,

	ExamList: styled.div`
		display: flex;
		flex-direction: column;
		gap: 16px;
		width: 100%;
	`,
	ExamElement: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;
		padding-bottom: 8px;
		border-bottom: 1px solid ${({theme}) => theme.color['grey2']};
	`,
	ExamTitleDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 2px;

		& > h1 {
			${({theme}) => theme.font['large-semibold']};
			line-height: 15px;
			font-size: 13px;
		}

		& > h2 {
			${({theme}) => theme.font['xsmall-medium']};
			line-height: 13px;
			font-size: 11px;
		}

		& > p {
			${({theme}) => theme.font['tiny-regular']};
			color: ${({theme}) => theme.color['grey3']};
			line-height: 11px;
			font-size: 9px;
		}
	`,
	TakingButtonDiv: styled.div`
		width: 72px;
		min-width: 72px;
	`,

	BranchSection: styled.div`
		display: flex;
		flex-direction: column;
		gap: 0;
		width: 100%;
	`,

	BranchHeader: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 14px 8px 0px 8px;
		border: 1px solid ${({theme}) => theme.color['grey2']};
		cursor: pointer;
		border-radius: ${({theme, $isExpanded}) =>
			$isExpanded ? '4px 4px 0 0' : '4px'};
		border-bottom: ${({theme, $isExpanded}) =>
			$isExpanded ? 'none' : `1px solid ${theme.color['grey2']}`};
		height: 39px;
	`,

	BranchHeaderContent: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 8px;
		border-bottom: ${({theme, $isExpanded}) =>
			$isExpanded ? `1px solid ${theme.color['grey2']}` : 'none'};

		& > h1 {
			${({theme}) => theme.font['large-semibold']};
			line-height: 11px;
		}
	`,

	ExpandIcon: styled.span`
		${({theme}) => theme.font['medium-regular']};
		transition: transform 0.2s ease;
		color: ${({theme}) => theme.color['grey4']};
		display: flex;
		align-items: center;
		justify-content: center;

		& > svg {
			width: 13px;
			height: 13px;
		}
	`,

	BranchContent: styled.div`
		display: flex;
		flex-direction: column;
		gap: 8px;
		padding: 12px 8px;
		border-left: 1px solid ${({theme}) => theme.color['grey2']};
		border-right: 1px solid ${({theme}) => theme.color['grey2']};
		border-bottom: 1px solid ${({theme}) => theme.color['grey2']};
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
		margin-top: -1px;
		& > div:last-child {
			border-bottom: none;
		}
	`,
}
